import styled from "styled-components";

export const Container = styled("div")`
  position: relative;
  margin: 8.0rem 8.2rem;

  h6 {
    color: #474747;
    text-transform: uppercase;
    text-align: center;
    font-size: 1.6rem;
    font-weight: 800;
    line-height: 3.2rem;

    @media screen and (max-width: 899px) {
      font-size: 2.333rem;
      line-height: 160%;
    }
  }

  @media screen and (max-width: 767px) {
    margin: 10.0rem 2.666rem;
  }
`;

export const Logos = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4.0rem;
  margin-top: 8.0rem;
  
  @media screen and (max-width: 767px) {
    margin-top: 4.0rem;
    gap: 3.333rem;
  }
`;

export const LogoWrapper = styled("div")`
  width: 25.0rem;
  height: 10.0rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 899px) {
    img {
      max-width: 200px;
    }
  }

  @media screen and (max-width: 575px) {
    img {
      max-width: 50px;
    }

    &:first-of-type img {
      max-width: 100px;
    }

    &:last-of-type img {
      max-width: 150px;
    }
  }
`;